import { useEffect, useState } from 'react'

const useIsSafari = () => {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent
    const isSafariBrowser =
      userAgent.includes('Safari') &&
      !userAgent.includes('Chrome') &&
      !userAgent.includes('Chromium')

    setIsSafari(isSafariBrowser)
  }, [])

  return isSafari
}

export default useIsSafari
